module.exports = __webpack_public_path__ + "static/images/footer_bg.929512a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newPromotionImg/footer_bg.png
// module id = KoME
// module chunks = 11